var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbsDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.40519 8.70011L8.20514 15C8.76209 15 9.29622 14.7788 9.69004 14.3849C10.0839 13.9911 10.3051 13.457 10.3051 12.9L10.3051 10.1001H14.267C14.47 10.1024 14.671 10.0605 14.8561 9.97744C15.0413 9.89434 15.2061 9.77198 15.3393 9.61884C15.4725 9.46569 15.5708 9.28543 15.6273 9.09053C15.6839 8.89563 15.6975 8.69076 15.667 8.49012L14.701 2.19023C14.6504 1.8564 14.4808 1.55212 14.2236 1.33344C13.9663 1.11477 13.6387 0.996436 13.3011 1.00025L5.40519 1.00025M5.40519 8.70011L5.40519 1.00025M5.40519 8.70011L3.53623 8.70011C3.14006 8.70712 2.75511 8.56842 2.45446 8.31035C2.1538 8.05227 1.95837 7.69279 1.90526 7.30014V2.40023C1.95837 2.00758 2.1538 1.64809 2.45446 1.39002C2.75511 1.13195 3.14006 0.993247 3.53623 1.00025L5.40519 1.00025",
    stroke: "#184C92",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsDown);
export default __webpack_public_path__ + "static/media/thumbsDown.f06809351de2a0ffb0027ebc07fbc950.svg";
export { ForwardRef as ReactComponent };